import angular from 'angular'
import template from './template.html'

export class NominasNominaInformacionAfEditarComponent {
  constructor($q, $catalogos, NominasNominaInformacionAf) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.NominasNominaInformacionAf = NominasNominaInformacionAf
    this.idEmpresa = undefined
    this.idNomina = undefined
    this.indice = undefined
    this.acumulado = undefined
    this.calculado = undefined
    this.onChange = undefined
    this.onClose = undefined
  }

  $onInit() {
    this.$promise = this.$q.all([
        this.NominasNominaInformacionAf.get(this.idEmpresa, this.idNomina, this.indice)
          .then((response) => (this.data = response.data)),
        this.$catalogos.get('clientes')
          .then((response) => this.clientes = response),
        this.$catalogos.get('cuentasBancarias')
          .then((response) => this.cuentasBancarias = response),
      ])
      .finally(() => (this.filtrarCuentas()))
  }

  actualizar() {
    if (this.actualizando) return

    this.error = null
    this.actualizando = true

    this.NominasNominaInformacionAf.put(this.idEmpresa, this.idNomina, this.indice, this.data)
      .then((response) => (this.onChange({$event: {data: response.data}})))
      .catch((response) => (this.error = response.data)) // Todo: Mostrar mensaje de error en interface
      .finally(() => (this.actualizando = false))
  }

  filtrarCuentas() {
    // Fixme: estos valores deben de ser números y el nombre del campo estar en minúsculas
    this.cuentasMxn = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.data.id_cliente && item.ID_Moneda === '1')
    // Fixme: estos valores deben de ser números y el nombre del campo estar en minúsculas
    this.cuentasUsd = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.data.id_cliente && item.ID_Moneda === '2')
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaInformacionAfEditar', {
    controller: NominasNominaInformacionAfEditarComponent,
    template: template,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      indice: '<',
      acumulado: '<',
      calculado: '<',
      onChange: '&',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/af/editar/component.js